/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_S9_P3Inputs */

const tr_kullanim_s9_p3 = /** @type {(inputs: Kullanim_S9_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Şirket, üçüncü taraf sağlayıcıların (pazaryerleri, QNB, kargo sağlayıcıları vb.) hizmet kesintilerinden ve işlem hatalarından sorumlu değildir.`)
};

const en_kullanim_s9_p3 = /** @type {(inputs: Kullanim_S9_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Company is not liable for service interruptions and processing errors of third-party providers (marketplaces, QNB, shipping providers, etc.).`)
};

const de_kullanim_s9_p3 = /** @type {(inputs: Kullanim_S9_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Unternehmen haftet nicht für Dienstunterbrechungen und Verarbeitungsfehler von Drittanbietern (Marktplätze, QNB, Versanddienstleister usw.).`)
};

const ru_kullanim_s9_p3 = /** @type {(inputs: Kullanim_S9_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Компания не несёт ответственности за перерывы в обслуживании и ошибки обработки со стороны сторонних поставщиков (маркетплейсы, QNB, службы доставки и т. п.).`)
};

/**
* | output |
* | --- |
* | "The Company is not liable for service interruptions and processing errors of third-party providers (marketplaces, QNB, shipping providers, etc.)." |
*
* @param {Kullanim_S9_P3Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_s9_p3 = /** @type {((inputs?: Kullanim_S9_P3Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_S9_P3Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_s9_p3(inputs)
	if (locale === "de") return de_kullanim_s9_p3(inputs)
	if (locale === "ru") return ru_kullanim_s9_p3(inputs)
	return tr_kullanim_s9_p3(inputs)
});